import { OptimisticEventPayload } from 'types/actions/optimistic';

// Map of listeners for each device - supports multiple listeners per device
const listeners: Record<string, Array<(e: CustomEvent<OptimisticEventPayload>) => void>> = {};

const dispatchEvent = ({ leafId, data }: OptimisticEventPayload) => {
  window.dispatchEvent(
    new CustomEvent('LEAF_OPTIMISTIC_CHANGE', {
      detail: {
        leafId,
        data,
      },
    }),
  );
};

const subscribe = (leafId: string, listener: (e: CustomEvent<OptimisticEventPayload>) => void) => {
  // Support multiple listeners per device for group ↔ member coordination
  if (!listeners[leafId]) {
    listeners[leafId] = [];
  }

  listeners[leafId].push(listener);
  window.addEventListener('LEAF_OPTIMISTIC_CHANGE', listener as EventListener);
};

const unsubscribe = (leafId: string, listener: (e: CustomEvent<OptimisticEventPayload>) => void) => {
  const deviceListeners = listeners[leafId];
  if (deviceListeners) {
    const index = deviceListeners.indexOf(listener);
    if (index > -1) {
      deviceListeners.splice(index, 1);
      window.removeEventListener('LEAF_OPTIMISTIC_CHANGE', listener as EventListener);

      // Clean up empty arrays
      if (deviceListeners.length === 0) {
        delete listeners[leafId];
      }
    }
  }
};

export { dispatchEvent, subscribe, unsubscribe };
